import {fabric} from 'fabric';

fabric.Video = fabric.util.createClass(fabric.Image, {
  type: 'video',

  initialize(src, options = {}) {
    this.filters = [];
    this.callSuper('initialize', options);

    const videoElement = document.createElement('video');
    videoElement.setAttribute('src', src);
    videoElement.setAttribute('width', '1000');
    videoElement.setAttribute('height', '1360');
    videoElement.setAttribute('style', 'display: none');

    videoElement.loop = true;
    videoElement.controls = false;
    videoElement.autoplay = true;
    videoElement.defaultMuted = true;
    videoElement.playsInline = true;
    videoElement.muted = true;
    videoElement.playsInline = true;
    videoElement.crossOrigin = 'anonymous';
    this._initElement(videoElement, options);

    // prevent video from playing on before page load
    setTimeout(() => videoElement.play(), 100);
  },
});

fabric.Video.fromObject = ({src, ...object}, callback) => {
  const image = new fabric.Video(src, object);
  callback?.(image, false);
};
